import { useGetSessionId } from "@Data-Protocol/event-tracker"
import { useSetAtom } from "jotai"
import { useEffect } from "react"
import { useAtomValue } from "~/atoms"
import { aFeedbackData, aFeedbackQuestion, aFeedbackReady } from "~/atoms/questions"
import useIsSmallScreen from "./useIsSmallScreen"

export function usePrefillFeedbackData(
  videoId: string | undefined,
  showFeedback: boolean | undefined
) {
  const sessionId = useGetSessionId()
  const question = useAtomValue(aFeedbackQuestion)
  const setFeedbackData = useSetAtom(aFeedbackData)
  const setFeedbackReady = useSetAtom(aFeedbackReady)
  const isSmall = useIsSmallScreen()

  const questionText = isSmall
    ? question.phoneQuestion
    : question.desktopQuestion

  useEffect(() => {
    setFeedbackData((prev) => ({
      ...prev,
      feedback_question: questionText,
      feedback_question_id: question.questionId,
    }))
  }, [questionText, question.questionId])

  useEffect(() => {
    if (!sessionId || !videoId || !showFeedback) return

    fetch(
      `/api/feedback?sessionId=${sessionId}&videoId=${videoId}&questionKey=thumbsUpDown`
    )
      .then((res) => res.json())
      .then((data: { feedback_gave: "positive" | "negative" } | null) => {
        if (
          data?.feedback_gave === "positive" ||
          data?.feedback_gave === "negative"
        ) {
          setFeedbackData((prev) => ({
            ...prev,
            feedback_question_state: "answered",
            feedback_answer_state: data.feedback_gave,
            feedback_question: questionText,
            feedback_question_id: question.questionId,
          }))
        }
        setFeedbackReady(true)
      })
      .catch(() => { setFeedbackReady(true) })
  }, [sessionId, videoId, showFeedback])
}
